import {AddUkerComponent} from './ukers/add-uker/add-uker.component';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {AuthInterceptor} from './auth.interceptor';
import {AuthService} from '@services/auth.service';
import {BankAccountComponent} from './bank-account/bank-account.component';
import {BankAccountPreviewComponent} from './common/components/bank-account-preview/bank-account-preview.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {CompanyDetailComponent} from "./account/company-detail/company-detail.component";
import {ConfirmationDialogComponent} from './common/confirmation-dialog/confirmation-dialog.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {DepositComponent} from './transactions/deposit/deposit.component';
import {DepositSummaryComponent} from './transactions/deposit-summary/deposit-summary.component';
import {ErrorInterceptor} from './error.interceptor';
import {ForgotPasswordComponent} from './enrollment/forgot-password/forgot-password.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GenericInfoComponent} from './common/components/generic-info/generic-info.component';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {HeaderComponent} from './layout/header/header.component';
import {ImageService} from '@services/image.service';
import {PaymentDetailComponent} from './transactions/payment/detail/payment-detail.component';
import {ListUkersComponent} from './ukers/list-ukers/list-ukers.component';
import {MainLayoutComponent} from './layout/main-layout/main-layout.component';
import {PaymentMultipleComponent} from './transactions/payment/multiple/payment-multiple.component';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog'
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from "@angular/material/list";
import {MatMenuModule} from '@angular/material/menu'
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar'
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table'
import {MatTabsModule} from "@angular/material/tabs";
import {MatTooltipModule} from "@angular/material/tooltip";
import {NgApexchartsModule} from 'ng-apexcharts';
import {NgModule} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {NgxSpinnerModule} from "ngx-spinner";
import {PaymentComponent} from "./transactions/payment/payment.component";
import {PaymentListComponent} from './transactions/payment/list/payment-list.component';
import {SettingsComponent} from './account/settings/settings.component';
import {SharedService} from '@services/shared.service';
import {SidemenuComponent} from './layout/sidemenu/sidemenu.component';
import {SigninComponent} from './enrollment/signin/signin.component';
import {SignupComponent} from './enrollment/signup/signup.component';
import {StablecoinWalletComponent} from "./stablecoin-wallet/stablecoin-wallet.component";
import {StablecoinWalletPreviewComponent} from './common/components/stablecoin-wallet-preview/stablecoin-wallet-preview.component';
import {TableDateComponent} from './common/components/transaction-date/transaction-date.component';
import {ToastrModule} from 'ngx-toastr';
import {TransactionAmountComponent} from './common/components/transaction-amount/transaction-amount.component';
import {TransactionCurrencyComponent} from './common/components/transaction-currency/transaction-currency.component';
import {TransactionIconComponent} from './common/components/transaction-icon/transaction-icon.component';
import {TransactionStatusComponent} from './common/components/transaction-status/transaction-status.component';
import {TransactionSuccessfulComponent} from './transactions/transaction-successful/transaction-successful.component';
import {UkerInfoComponent} from './common/components/uker-info/uker-info.component';
import {TransferComponent} from './transactions/transfer/transfer.component';
import {TransferSummaryComponent} from './transactions/transfer-summary/transfer-summary.component';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TwoDigitDecimalDirective} from './common/directives/two-digit-decimal.directive';
import {UserDetailComponent} from './account/user-detail/user-detail.component';
import {WalletsComponent} from './wallets/wallets.component';
import {WithdrawalComponent} from './transactions/withdrawal/withdrawal.component';
import {WithdrawalSummaryComponent} from './transactions/withdrawal-summary/withdrawal-summary.component';
import {authGuardGuard} from './auth-guard.guard';
import {SearchBarComponent} from "./common/components/search-bar/search-bar.component";
import {MatChipsModule} from "@angular/material/chips";
import {PaymentSingleComponent} from "./transactions/payment/single/payment-single.component";

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    AddUkerComponent,
    AppComponent,
    BankAccountComponent,
    BankAccountPreviewComponent,
    CompanyDetailComponent,
    ConfirmationDialogComponent,
    DashboardComponent,
    DepositComponent,
    DepositSummaryComponent,
    ForgotPasswordComponent,
    GenericInfoComponent,
    HeaderComponent,
    ListUkersComponent,
    MainLayoutComponent,
    PaymentComponent,
    PaymentDetailComponent,
    PaymentListComponent,
    PaymentMultipleComponent,
    PaymentSingleComponent,
    SearchBarComponent,
    SettingsComponent,
    SidemenuComponent,
    SigninComponent,
    SignupComponent,
    StablecoinWalletComponent,
    StablecoinWalletPreviewComponent,
    TableDateComponent,
    TransactionAmountComponent,
    TransactionCurrencyComponent,
    TransactionIconComponent,
    TransactionStatusComponent,
    TransactionSuccessfulComponent,
    TransferComponent,
    TransferSummaryComponent,
    TwoDigitDecimalDirective,
    UkerInfoComponent,
    UserDetailComponent,
    WalletsComponent,
    WithdrawalComponent,
    WithdrawalSummaryComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    NgApexchartsModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgOptimizedImage,
    MatListModule,
    MatChipsModule
  ],
  providers: [AuthService, authGuardGuard, SharedService, ImageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
